<template>

    <m-edit1/>

    <m-dashboard-layout-2 v-bind='{...{"menuPosition":"store_nav","sideBar":"col-lg-3","contentWrapper":"col-lg-9"},...{}}' :style='""' class="my-2" >
                <template #p-2>   <m-h5 v-bind='{...{},...{}}' :style='"font-size: 13px;\n"' class="my-3 border-bottom pb-2" >
                <template #default>لیست سفارشات   </template>
                </m-h5><m-orders-1 v-bind='{...{"order_id_prop":true,"user_prop":true,"user_profile_prop":true,"user_description_prop":true,"order_paying_amount_prop":false,"order_paying_status_prop":false,"order_status_prop":false,"order_created_at_prop":false,"order_updated_at_prop":false,"order_transaction_updated_at_prop":false,"actions_prop":true,"order_items_prop":true,"user_cellphone_prop":true,"order_description_prop":true,"dashboardOrders":true},...{}}' :style='""' class="" ></m-orders-1></template>
                </m-dashboard-layout-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardLayout2 from '@moeinmdn/miw-alpha-components/src/package/DashboardLayout/DashboardLayout2'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mOrders1 from '@moeinmdn/miw-alpha-components/src/package/Order/Orders1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardLayout2,mH5,mOrders1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
